import { Component, OnInit } from '@angular/core';
import { OfflineModeService } from '../../service/offline-mode.service';
import { ThisReceiver } from '@angular/compiler';
import { LoginService } from '../../service/login.service';
import { Route, Router } from '@angular/router';
import { SessionLogRequestModel } from '../../model/sessionLogsRequest.model';
import { SessionLogsEnum } from '../../model/sessionLogs.enum';
import { PageModel } from '../../model/page.model';
import { SessionLogsService } from '../../service/session-logs.service';
import { SessionLogResponseModel } from '../../model/sessionLogResponse.model';

@Component({
  selector: 'app-offline-dashboard',
  templateUrl: './offline-dashboard.component.html',
  styleUrls: ['./offline-dashboard.component.scss']
})

export class OfflineDashboardComponent implements OnInit {
  /**
   * Variable for storing data from txn api
   */
  offlineData: string | any;
  /**
   * Details array for txn table
   */
  txnDetails : any = []
  /**
   * Initial value of total records count
   */
  totalRecordCount = 15;
  /**
   * initial value of records count
   */
  recordsCount = 10;
  /**
   * initial value of page number
   */
  pageNumber = 1;
  /**
   * intial value of fromRow
   */
  fromRow: number = 1;
  /**
   * store value of CHECK_OUT from sessionLogsEnum
   */
  logType: number = SessionLogsEnum.CHECK_OUT;
  /**
   * store the value of Selected user while applying filters
   */
  selectedUser: any;
  /**
   * user to store startDate while applying filtrs
   */
  startDate: Date;
  /**
   * user to store endDate while applying filters
   */
  endDate: Date;
  /**
   * Array used to strore user list
   */
  usersList: Array<any> = [];
  /** 
   * Used for storing error message 
  */
  errorMsg: string;
  /**
   * Array of type sessionLogResponseModel
   */
  sessionLogs: Array<SessionLogResponseModel> = [];

  constructor(
    private offlineService: OfflineModeService, 
    private loginService : LoginService, 
    private router : Router,
    private sessionLogsService: SessionLogsService
    ) { }

  ngOnInit(): void {
    this.offlineService.dataInRfidOfflineOBS.subscribe(data => {
      if (data) {
        this.offlineData = data.split(" ");
      }
    })

    // console.log(this.offlineData[0])

      let transaction_date = ""
      let transaction_time = ""
      let operation = ""
      let item_identifier = ""
      let item_type = ""
      let patron_id = ""
      let admin = ""

      let count = 0;

      setTimeout(()=>{
        for(let x in this.offlineData[0]){

          let obj = {
            "transaction_date" : "",
            "transaction_time" : "",
            "operation" : "",
            "item_identifier" : "",
            "item_type" : "",
            "patron_id" : "",
            "admin" : "" ,
            "status" : ""
          }

          if(this.offlineData[0][x] == "\t"){
           count++;
          }
          else if(this.offlineData[0][x] == "\n"){
            obj['transaction_date'] = transaction_date;
            obj['transaction_time'] = transaction_time;
            obj['operation'] = operation;
            obj['item_identifier'] = item_identifier;
            obj['item_type'] = item_type;
            obj['patron_id'] = patron_id;
            obj['admin'] = admin;
            obj['status'] = ""
    
            this.txnDetails.push(obj);
            count = 0
   
            transaction_date = ""
            transaction_time = ""
            operation = ""
            item_identifier = ""
            item_type = ""
            patron_id = ""
            admin = ""

          }
          else{
            if(count == 0){
              transaction_date = transaction_date + this.offlineData[0][x]
            }
            if(count == 1){
              transaction_time = transaction_time + this.offlineData[0][x]
            }
            else if(count == 2){
              operation = operation + this.offlineData[0][x]
            }
            else if(count == 3){
              item_identifier = item_identifier + this.offlineData[0][x]
            }
            else if(count == 4){
              item_type = item_type + this.offlineData[0][x]
            }
            else if(count == 5){
              patron_id = patron_id + this.offlineData[0][x]
            }
            else if(count == 6){
              admin = admin + this.offlineData[0][x]
            }
          }
        }
        // console.log(this.txnDetails,"txnDetails")

    if (this.offlineData)
      this.getOfflineData(); 
    
      },100)
    }

  getOfflineData() {
    console.log(this.offlineData)
    let body = {};
    body["offlineTxnRecordString"] = this.offlineData[0];
    this.offlineService.setOfflineTxnProcess(body, resp => {
      console.log(resp);

      this.txnDetails.forEach((ele, idx)=>{
        ele['status'] = resp.data[idx].circulationResponse[0].screen_msg
      })
    })
  }

  exitClicked(){
    this.loginService.adminExitActions();
    this.router.navigate(["/login"]);
  }

  /**
   * This method executed when we change pages
   * @param event on click
   */
  pageChanged(event) {
    console.log("event", event);

    if (event.page != this.pageNumber) {
      this.pageNumber = event.page;
      this.fromRow = event.fromRow;
      this.fetchLogs(); 
    }
  }

   /**
   * This method used for fetching Logs
   * Here requestModel is instance of SessionLogRequestModel , storing value of logType, page number , records count
   * this request model is used while we send the service for fetching logs
   */

  fetchLogs() {
    let requestModel: SessionLogRequestModel = new SessionLogRequestModel();
    requestModel.logType = this.logType;
    requestModel.pageNo = this.pageNumber;
    requestModel.recordsCount = this.recordsCount;
    if (this.selectedUser) {
      requestModel.optionalLoginId = this.usersList[this.selectedUser[0]].value;
    }
    if(this.startDate){
      let options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }as const;
     requestModel.optionalStartDate = this.startDate.toLocaleDateString("en-GB", options);  
      
      // if(temp.includes('/')){
      //  let tempDate =  temp.split('/');
      //  console.log(tempDate);
      //  requestModel.optionalStartDate = tempDate.join("/") + '';
      //  console.log(requestModel.optionalStartDate);
      // }
    }
    if(this.endDate){
      let options = {
        day: "2-digit",
        month: "2-digit",  
        year: "numeric"
      }as const;
      requestModel.optionalEndDate = this.endDate.toLocaleDateString("en-GB", options);
      
      // if(temp.includes('/')){ 
      //   let tempDate = temp.split('/');
      //   requestModel.optionalEndDate = tempDate.join("/") + '';
      // }
    }
    this.sessionLogsService.fetchLogs(requestModel, (resp) => { 
      if (resp && resp.data) {
        let page: PageModel = resp.data;
        if (page.data && page.data.length) { 
          this.errorMsg=""
          this.sessionLogs = page.data;
          if (page.count != this.totalRecordCount) {
            this.totalRecordCount = page.count;
          }
        } else {
         
        }
      } else {
        //console.log("no data found")     
          this.errorMsg = resp.message;
          
      }
    });
  }
}
